import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

// Securely fetches a private file as a blob (sends auth cookie + bearer) and renders it.
export const SecureImage = ({ fileId, alt = "document", className = "", testId }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoked = null;
    let active = true;
    if (!fileId) return;
    setUrl(null);
    setErr(false);
    api
      .get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        const blobUrl = URL.createObjectURL(res.data);
        revoked = blobUrl;
        setUrl(blobUrl);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [fileId]);

  if (!fileId) return null;
  if (err)
    return (
      <div className={`grid place-items-center bg-slate-100 text-slate-400 ${className}`}>
        <ImageOff className="h-6 w-6" />
      </div>
    );
  if (!url)
    return (
      <div className={`grid place-items-center bg-slate-100 ${className}`}>
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
      </div>
    );
  return <img data-testid={testId} src={url} alt={alt} className={className} />;
};
